import { forOwn, isNull, isNaN, isUndefined, clone } from 'lodash';

interface Params {
  [p: string]: any;
}
export function noDataFilter(data: Params) {
  const p = clone(data);

  return forOwn(p, function (value, key) {
    if (
      isNaN(value) ||
      isNull(value) ||
      isUndefined(value) ||
      value === 'null' ||
      value === 'undefined'
    ) {
      Reflect.deleteProperty(p, key);
    }
  });
}
